module.exports = __webpack_public_path__ + "img/black_card.e87fe960.png";